import Vue from 'vue';
import Vuex from 'vuex';
import templateDesigner from '@/store/modules/templateDesigner.js';
import scheduler from '@/store/modules/scheduler.js';
import products from '@/store/modules/products.js';
import notifications from '@/store/modules/notifications.js';
import caller from '@/store/modules/caller.js';
import users from '@/store/modules/users.js';
import auth from '@/store/modules/auth.js';
import systemAdmin from '@/store/modules/systemAdmin.js';
import customer from '@/store/modules/customer.js';
import printBooks from '@/store/modules/printBooks.js';
import reporting from '@/store/modules/reporting.js';
import books from '@/store/modules/books.js';
import tenants from '@/store/modules/tenants.js';
import navigation from './modules/navigation';
import sales from '@/store/modules/sales.js';
import createPersistedState from 'vuex-persistedstate';
import sessionReporting from './modules/sessionReporting';
import device from '@/store/modules/device.js';
Vue.use(Vuex);

const TRANSIENT_AUTH_KEYS = ['isRefreshingToken', 'refreshPromise', 'refreshTimer'];

export default new Vuex.Store({
  modules: {
    templateDesigner,
    scheduler,
    products,
    notifications,
    caller,
    users,
    tenants,
    auth,
    systemAdmin,
    customer,
    printBooks,
    reporting,
    books,
    navigation,
    sales,
    device,
  sessionReporting  },
  plugins: [
    createPersistedState({
      paths: ['auth.token', 'auth.requiresPasswordReset', 'auth.email', 'auth.id', 'auth.refreshToken', 'auth.roles', 'auth.userName', 'auth.expiresAt'],
      getState: (key, storage) => {
        try {
          const saved = JSON.parse(storage.getItem(key));
          if (saved && saved.auth) TRANSIENT_AUTH_KEYS.forEach(k => delete saved.auth[k]);
          return saved || undefined;
        } catch (e) {
          return undefined;
        }
      },
    }),
  ],
})
